<template>
  <form ref="inputwvk">
    <div class="d-flex">
      <v-text-field
        v-model="currentVal"
        :label="label"
        ref="inputHolder"
        @focus="inputFocus"
        @keydown="inputKeydown"
        @keypress="inputKeyPress"
        :placeholder="placeholder"
        readonly
        :autofocus="autofocus"
        :append-icon="appendIcon"
        :type="type"
      ></v-text-field>
      <a
        href="#"
        class="flex-grow-0 d-flex align-items-center pl-2"
        @click="clearInput"
        :tabindex="-1"
        ><i aria-hidden="true" class="v-icon material-icons">close</i></a
      >
    </div>
    <div class="keyboard-holder" v-if="focused">
      <virtual-keyboard @key="sendKey" :numeric="true" />
    </div>
  </form>
</template>

<script>
import helpers from '../services/helpers'
import i18n from '@/plugins/i18n'

export default {
  name: 'InputWithVKeyboard',
  components: {
    'virtual-keyboard': async () => await import('./VirtualKeyboard.vue'),
  },
  props: {
    inputVal: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    appendIcon: {
      type: String,
    },
    numeric: {
      type: Boolean,
    },
    autoclean: {
      type: Boolean,
    },
    autofocus: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    forceHideKeyboard: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    currentVal: '',
    focused: false,
  }),
  computed: {
    isNumeric: function() {
      return this.numeric
    },
    globalTexts: function() {
      return i18n.messages[i18n.locale].global
    },
  },
  mounted: function() {
    this.currentVal = this.inputVal
    window.addEventListener('click',(ev)=>{
      if (ev.target.closest('form')!==this.$refs.inputwvk) {
        this.focused = false
      }
    })

  },
  methods: {
    getChar(event) {
      if (event.which == null) {
        // IE
        if (event.keyCode < 32) return '' // special symbol
        return String.fromCharCode(event.keyCode)
      }
      if (event.which !== 0 && event.charCode !== 0) {
        // except IE
        if (event.which < 32) return '' // special symbol
        return String.fromCharCode(event.which) // rest
      }
      return '' // special symbol
    },
    inputKeyPress(ev) {
      const char = this.getChar(ev)
      if (this.isNumeric && isNaN(parseInt(char, 10))) {
        this.$emit('showSnack', {
          color: 'error',
          text: this.globalTexts.onlyNumbers,
        })
      } else {
        this.currentVal = this.currentVal + char
        this.$emit('change', this.currentVal)
      }
      this.inputFocus()
    },
    inputKeydown(ev) {
      switch (ev.keyCode) {
        case 13:
          if (ev.preventDefault) ev.preventDefault()
          this.$emit('input', this.currentVal)
          if (this.autoclean) {
            this.currentVal = ''
          }
          this.focused = false
          break
        case 27:
          if (ev.preventDefault) ev.preventDefault()
          this.currentVal = ''
          this.focused = false
          break
        case 8:
          if (ev.preventDefault) ev.preventDefault()
          this.currentVal = this.currentVal.substring(
            0,
            this.currentVal.length - 1
          )
          this.inputFocus()
          break
      }
    },
    inputFocus() {
      this.focused = true
    },
    sendKey(payload) {
      if (payload.length === 1) {
        const charCode = payload.charCodeAt(0)
        const evData = {
          which: charCode,
          charCode: charCode,
        }
        this.$refs.inputHolder.$emit('keypress', evData)
      } else {
        if (payload === 'backspace')
          this.$refs.inputHolder.$emit(
            'keydown',
            Object.assign({}, { keyCode: 8 })
          )
        else if (payload === 'enter') {
          this.$refs.inputHolder.$emit(
            'keydown',
            Object.assign({}, { keyCode: 13 })
          )
        }
      }
    },
    clearInput() {
      this.currentVal = ''
      this.$emit('input', this.currentVal)
    },
  }, //methods
}
</script>

<style scoped lang="scss">
a {
  color: #fff;
  &:focus,
  &:hover {
    color: #fff;
    text-decoration: none;
  }
}
/deep/ .v-input {
  input::placeholder {
    font-size: 10px;
  }
}
</style>
